export default function scrollToFix() {
  let element = $('.scroll-fix');
  let parent = $('.scroll-fix-parent');

  $(window).on('scroll', function () {
    // let parentOffset = parent.offset().top + parent.height() - element.outerHeight();
    
    if ($(window).width() > 767) {
      if (parent.offset().top >= $(this).scrollTop()) {
        element.removeClass('fixed');
      } else if (parent.offset().top + parent.height() - element.outerHeight() >= $(this).scrollTop()) {
        element.addClass('fixed');
      } else {
        element.removeClass('fixed');
      }
      // if (parent.offset().top + parent.height() >= $(this).scrollTop()) {
      //   element.removeClass('fixed');
      // }
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToFix.js